import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Image } from "react-bootstrap";
import Wrike_Image from "../../../assests/images/our-supporters/wrike-image.webp";
import {
    OurSupportersMain,
    OurSupportersBox,
    OurSupportBoxInner,
    SupportersMainLogo,
} from "./ourSupportersStyle";
import { AdvocacyTitle, ElliottAdvocacyBanner } from "../../../components/common/commonSubPageBanner/commonSubPageBannerStyle";
import { useSelector, useDispatch } from "react-redux";
import { supportersHandler } from "../../../redux/slices/supporters/supporters";
import { MESSAGE } from "../../../utils/message";
import MetaComponent from "../../../components/common/metaComponent";

const OurSupporters = () => {
    const supportersList = useSelector((state:any) => state?.supporters?.data)
    const dispatch:any = useDispatch();
    const[allSupporters,setAllSupporters] = useState<string[]>([])

    useEffect(() => {
        dispatch(supportersHandler())
    },[])

    useEffect(() => {
       if(supportersList) {
        setAllSupporters(supportersList.data)
        }
    },[supportersList])
    return (
        <>
        <MetaComponent 
            keywords=""
            description=""
            ogTitle="Our Supporters | GreatNonprofits"
            ogDescription=""
            ogUrl="https://www.about.greatnonprofits.org/our-supporters"
            ogImage="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"
        />
        <>
        <ElliottAdvocacyBanner className="elliott-advocacy-banner">
           <Container className="cont-w">
               <AdvocacyTitle className='title-sub-page'>{MESSAGE.supportersTitle}</AdvocacyTitle>
            </Container>
        </ElliottAdvocacyBanner>
        <OurSupportersMain>
            <Container className="cont-w">
                 <SupportersMainLogo>
                <Row className="gray-back">
                    {allSupporters?.map((image:string,index:number) => 
                       ( 
                       <OurSupportersBox as={Col} sm="6" md="6" xl="4" key={index+1}>
                            <OurSupportBoxInner>
                              <Image src={Wrike_Image} alt={image} width="200" height="65" />
                            </OurSupportBoxInner>
                        </OurSupportersBox>
                      )
                    )}
                </Row>
                </SupportersMainLogo>
            </Container>
        </OurSupportersMain>
    </>
        </>
    )
};
export default OurSupporters;